//require('./debug-info-modal.component.scss');

export class DatabaseUsageModalController {
  constructor($scope, $modalInstance, ServerInformationService) {
    $scope.close = () => {
      $modalInstance.close();
    };
    $scope.databaseUsage = ServerInformationService.databaseUsage;
    $scope.databasePath = ServerInformationService.databasePath;
  }
}



// WEBPACK FOOTER //
// ./src/admin/database-usage-modal.component.js